const STORAGE_KEY = 'sofia-recently-viewed';
const MAX_STORED = 16;

function readHandles() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    const list = raw ? JSON.parse(raw) : [];
    return Array.isArray(list) ? list.filter((h) => typeof h === 'string' && h) : [];
  } catch (e) {
    return [];
  }
}

function writeHandles(handles) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(handles.slice(0, MAX_STORED)));
  } catch (e) {
    /* ignore quota / private mode */
  }
}

function trackHandle(handle) {
  if (!handle) return;
  const next = [handle, ...readHandles().filter((h) => h !== handle)];
  writeHandles(next);
}

class SofiaRecentlyViewed extends HTMLElement {
  connectedCallback() {
    const currentHandle = this.dataset.productHandle;
    if (currentHandle) trackHandle(currentHandle);

    const limit = Number(this.dataset.limit) || 10;
    const handles = readHandles().filter((h) => h !== currentHandle).slice(0, limit);

    if (!handles.length) {
      this.hidden = true;
      return;
    }

    this.loadProducts(handles);
  }

  async loadProducts(handles) {
    const grid = this.querySelector('[data-sofia-recently-grid]');
    const buttons = this.querySelector('[data-sofia-recently-buttons]');
    const totalEl = this.querySelector('[data-sofia-recently-total]');
    const sectionId = this.dataset.sectionId || 'recently';
    const columnsMobile = Number(this.dataset.columnsMobile) || 2;
    const columnsDesktop = Number(this.dataset.columnsDesktop) || 5;
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    try {
      const cards = await Promise.all(
        handles.map(async (handle) => {
          const url = `${root}products/${encodeURIComponent(handle)}?sections=sofia-product-card`;
          const res = await fetch(url);
          if (!res.ok) return null;
          const json = await res.json();
          const html = json['sofia-product-card'];
          if (!html) return null;
          const wrap = document.createElement('div');
          wrap.innerHTML = html;
          return wrap.querySelector('.sofia-product-card');
        })
      );

      const valid = cards.filter(Boolean);
      if (!valid.length || !grid) {
        this.hidden = true;
        return;
      }

      grid.innerHTML = '';
      // Single-row carousel on mobile and desktop (no wrapped second row)
      grid.classList.add('slider', 'slider--tablet', 'slider--desktop', 'grid--peek');

      valid.forEach((card, index) => {
        const li = document.createElement('li');
        li.id = `Slide-${sectionId}-${index + 1}`;
        li.className = 'grid__item slider__slide';
        li.appendChild(card);
        grid.appendChild(li);
      });

      const canScroll = valid.length > columnsMobile || valid.length > columnsDesktop;
      if (buttons) buttons.hidden = !canScroll;
      if (totalEl) totalEl.textContent = String(valid.length);

      this.hidden = false;
      this.classList.toggle('sofia-recently-viewed--single', valid.length === 1);
      this.classList.add('sofia-recently-viewed--loaded');
      this.refreshSlider();
      window.dispatchEvent(new CustomEvent('sofia:recently-viewed:loaded'));
    } catch (e) {
      console.error(e);
      this.hidden = true;
    }
  }

  refreshSlider() {
    const slider = this.querySelector('slider-component');
    if (!slider) return;

    if (typeof slider.resetPages === 'function') {
      slider.resetPages();
      return;
    }

    const clone = slider.cloneNode(true);
    slider.replaceWith(clone);
  }
}

customElements.define('sofia-recently-viewed', SofiaRecentlyViewed);
